/* unplugin-vue-components disabled */import { render } from "./w-select.vue?vue&type=template&id=ef1e9564&scoped=true&ts=true"
import script from "./w-select.vue?vue&type=script&lang=ts"
export * from "./w-select.vue?vue&type=script&lang=ts"

import "./w-select.vue?vue&type=style&index=0&id=ef1e9564&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef1e9564"]])

export default __exports__